import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const fr = {
  common: {
    appName: 'Pokero',
    tagline: 'Le tournoi, sans les approximations.',
    loading: 'Chargement…',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    cancel: 'Annuler',
    close: 'Fermer',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    confirm: 'Confirmer',
    search: 'Rechercher',
    none: 'Aucun',
    optional: 'facultatif',
    required: 'requis',
    yes: 'Oui',
    no: 'Non',
    copy: 'Copier',
    copied: 'Copié !',
    retry: 'Réessayer',
    seconds: 'secondes',
    minutes: 'minutes',
    players: 'joueurs',
    player: 'joueur',
    level: 'niveau',
    break: 'pause',
    error: 'Une erreur est survenue.',
    unreachable: 'Le serveur est injoignable. Vérifiez votre connexion, puis réessayez.',
    networkError: 'Connexion au serveur impossible.',
  },
  nav: {
    dashboard: 'Tableau de bord',
    home: 'Accueil',
    chipCases: 'Mallettes',
    presets: 'Presets',
    stats: 'Statistiques',
    account: 'Compte',
    newTournament: 'Nouveau tournoi',
    create: 'Créer',
    logout: 'Se déconnecter',
  },
  auth: {
    login: 'Connexion',
    loginCta: 'Se connecter',
    register: 'Créer un compte',
    registerCta: 'Créer mon compte',
    email: 'Adresse email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    displayName: 'Pseudo',
    forgot: 'Mot de passe oublié ?',
    noAccount: 'Pas encore de compte ?',
    hasAccount: 'Déjà un compte ?',
    resetTitle: 'Réinitialiser le mot de passe',
    newPassword: 'Nouveau mot de passe',
    resetSent: 'Si un compte existe, un email vient d’être envoyé.',
    verifyTitle: 'Vérification de l’email',
    verifySuccess: 'Votre adresse email est confirmée.',
    verifyError: 'Lien invalide ou expiré.',
    logoutDone: 'Vous êtes déconnecté.',
    welcomeBack: 'Content de vous revoir',
    createAccount: 'Créez votre espace organisateur',
    passwordHint: 'Au moins 10 caractères.',
    emailVerificationRequired: 'Vérifiez votre boîte mail pour activer votre compte.',
  },
  status: {
    DRAFT: 'Brouillon',
    READY: 'Prêt',
    RUNNING: 'En cours',
    PAUSED: 'En pause',
    RECOVERY_PENDING: 'Récupération',
    COMPLETED: 'Terminé',
    CANCELLED: 'Annulé',
  },
  dashboard: {
    title: 'Tableau de bord',
    greeting: 'Bonjour {{name}}',
    subtitle: 'Vos tournois, vos mallettes, votre rythme.',
    activeTournament: 'Tournoi en cours',
    upcoming: 'À venir',
    recent: 'Récents',
    noTournaments: 'Aucun tournoi pour le moment.',
    createFirst: 'Créez votre premier tournoi',
    playersCount: '{{count}} joueurs',
    openConsole: 'Ouvrir la console',
    stats: 'Vos statistiques',
    tournamentsPlayed: 'Tournois joués',
    wins: 'Victoires',
    podiums: 'Podiums',
  },
  tournament: {
    new: 'Nouveau tournoi',
    name: 'Nom du tournoi',
    chipCase: 'Mallette de jetons',
    preset: 'Partir d’un preset',
    stepInfo: 'Informations',
    stepChips: 'Caves',
    stepBlinds: 'Structure',
    stepOptions: 'Options',
    playersExpected: 'Joueurs attendus',
    buyIn: 'Valeur de la cave',
    startingStack: 'Tapis de départ',
    targetDuration: 'Durée cible (min)',
    levelDuration: 'Durée d’un niveau (min)',
    firstLevelDuration: 'Premier niveau (min)',
    followingLevelDuration: 'Niveaux suivants (min)',
    breakDuration: 'Durée des pauses (min)',
    breakEvery: 'Pause toutes les',
    roundUnit: 'Arrondi des blindes',
    autoStructure: 'Générer automatiquement',
    manualStructure: 'Saisir manuellement',
    distribution: 'Distribution des caves',
    exactDistribution: 'Valeur exacte',
    approximateDistribution: 'Valeur approchée : écart de {{difference}}',
    chipsPerPlayer: '{{count}} jetons par joueur',
    start: 'Démarrer le tournoi',
    pause: 'Mettre en pause',
    resume: 'Reprendre',
    nextLevel: 'Niveau suivant',
    previousLevel: 'Niveau précédent',
    addMinute: '+1 min',
    addFiveMinutes: '+5 min',
    complete: 'Clôturer',
    cancelTournament: 'Annuler le tournoi',
    finalize: 'Déclarer le vainqueur',
    console: 'Console',
    players: 'Joueurs',
    structure: 'Structure',
    ranking: 'Classement',
    share: 'Partage',
    history: 'Historique',
    addPlayer: 'Ajouter un joueur',
    playerName: 'Nom du joueur',
    eliminate: 'Éliminer',
    undoElimination: 'Annuler la dernière élimination',
    rebuy: 'Rebuy',
    addOn: 'Add-on',
    rebuyCount: '{{count}} rebuy(s)',
    activePlayers: '{{count}} en course',
    spectatorLink: 'Lien spectateur',
    createSpectatorLink: 'Créer un lien spectateur',
    spectatorHint: 'Partagez ce lien : il donne un accès en lecture seule, révocable à tout moment.',
    revoke: 'Révoquer',
    projection: 'Mode projection',
    winner: 'Vainqueur',
    finalRanking: 'Classement final',
    noPlayers: 'Aucun joueur inscrit.',
    lateRegistration: 'Inscription tardive',
    pin: 'Code PIN de sécurité',
    pinHint: '4 à 8 chiffres. Facultatif, il verrouille les commandes du chronomètre.',
    unlock: 'Déverrouiller',
    pinRequired: 'Ce tournoi est protégé par un PIN.',
    buyInSummary: 'Cave de {{value}}',
    totalChips: '{{count}} jetons au total',
    stockWarning: 'Stock insuffisant',
    levelUpSoon: 'Niveau suivant dans',
    onBreak: 'Pause',
    structureExhausted: 'Structure épuisée : prolongez ou clôturez le tournoi.',
    extendStructure: 'Prolonger la structure',
  },
  chipCase: {
    title: 'Mallettes',
    subtitle: 'Votre inventaire physique de jetons.',
    new: 'Nouvelle mallette',
    edit: 'Modifier la mallette',
    name: 'Nom de la mallette',
    description: 'Description',
    chipLabel: 'Libellé',
    color: 'Couleur',
    value: 'Valeur',
    quantity: 'Quantité',
    addChipType: 'Ajouter un jeton',
    totalValue: 'Valeur totale du stock',
    uniqueValues: 'Chaque valeur doit être unique.',
    inUse: 'Utilisée par {{count}} tournoi(s)',
    adjust: 'Ajuster le stock',
    adjustmentReason: 'Motif de l’ajustement',
    freeStock: '{{count}} disponibles',
    empty: 'Aucune mallette. Créez la première pour commencer.',
  },
  preset: {
    title: 'Presets',
    subtitle: 'Vos configurations réutilisables.',
    new: 'Nouveau preset',
    edit: 'Modifier le preset',
    name: 'Nom du preset',
    description: 'Description',
    empty: 'Aucun preset enregistré.',
    use: 'Utiliser dans un tournoi',
    version: 'Version {{version}}',
  },
  stats: {
    title: 'Statistiques',
    subtitle: 'Votre parcours, tournoi après tournoi.',
    played: 'Tournois joués',
    wins: 'Victoires',
    podiums: 'Podiums',
    bestRank: 'Meilleure place',
    averageRank: 'Place moyenne',
    rebuys: 'Rebuys',
    addOns: 'Add-ons',
    noResults: 'Aucun résultat enregistré.',
    history: 'Historique des participations',
    rank: 'Place',
    tournament: 'Tournoi',
  },
  account: {
    title: 'Compte',
    subtitle: 'Profil, sécurité et données personnelles.',
    profile: 'Profil',
    security: 'Sécurité',
    data: 'Données',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    changePassword: 'Changer le mot de passe',
    exportData: 'Exporter mes données (JSON)',
    deleteAccount: 'Supprimer mon compte',
    deleteWarning:
      'Cette action est irréversible. Vos données personnelles sont supprimées et vos participations anonymisées.',
    deleteConfirm: 'Tapez SUPPRIMER pour confirmer.',
    publicProfile: 'Profil public',
    publicResults: 'Résultats publics',
    language: 'Langue',
    passwordChanged: 'Mot de passe mis à jour.',
    dataExported: 'Export téléchargé.',
    accountDeleted: 'Compte supprimé.',
  },
  spectator: {
    title: 'Tournoi en direct',
    waiting: 'Le tournoi n’a pas encore commencé.',
    players: 'Joueurs en course',
    ranking: 'Classement',
    live: 'Direct',
    invalid: 'Ce lien spectateur est invalide ou a été révoqué.',
  },
  errors: {
    INVALID_CREDENTIALS: 'Email ou mot de passe incorrect.',
    EMAIL_TAKEN: 'Un compte existe déjà avec cette adresse.',
    EMAIL_NOT_VERIFIED: 'Vérifiez votre adresse email avant de vous connecter.',
    CSRF_MISSING: 'Session expirée, rechargez la page.',
    CSRF_INVALID: 'Jeton de sécurité invalide, rechargez la page.',
    RATE_LIMITED: 'Trop de tentatives, patientez une minute.',
    VERSION_CONFLICT: 'Le chronomètre a changé entre-temps. Actualisez.',
    PIN_REQUIRED: 'Déverrouillez le tournoi avec son PIN.',
    INVALID_PIN: 'PIN incorrect.',
    INSUFFICIENT_STOCK: 'Stock de jetons insuffisant.',
    NOT_ENOUGH_PLAYERS: 'Il faut au moins deux joueurs.',
    DUPLICATE_PARTICIPANT: 'Ce nom est déjà utilisé dans ce tournoi.',
    PLAYERS_REMAIN: 'Des joueurs sont encore en course.',
    REBUY_LIMIT_REACHED: 'Limite de rebuys atteinte.',
    REBUY_PERIOD_OVER: 'La période de rebuy est terminée.',
    UNKNOWN: 'Une erreur est survenue.',
  },
} as const;

const en = {
  common: {
    appName: 'Pokero',
    tagline: 'Tournaments, without the guesswork.',
    loading: 'Loading…',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    confirm: 'Confirm',
    search: 'Search',
    none: 'None',
    optional: 'optional',
    required: 'required',
    yes: 'Yes',
    no: 'No',
    copy: 'Copy',
    copied: 'Copied!',
    retry: 'Retry',
    seconds: 'seconds',
    minutes: 'minutes',
    players: 'players',
    player: 'player',
    level: 'level',
    break: 'break',
    error: 'Something went wrong.',
    unreachable: 'The server is unreachable. Check your connection and try again.',
    networkError: 'Cannot reach the server.',
  },
  nav: {
    dashboard: 'Dashboard',
    home: 'Home',
    chipCases: 'Chip cases',
    presets: 'Presets',
    stats: 'Stats',
    account: 'Account',
    newTournament: 'New tournament',
    create: 'Create',
    logout: 'Sign out',
  },
  auth: {
    login: 'Sign in',
    loginCta: 'Sign in',
    register: 'Create account',
    registerCta: 'Create my account',
    email: 'Email address',
    password: 'Password',
    confirmPassword: 'Confirm password',
    displayName: 'Display name',
    forgot: 'Forgot password?',
    noAccount: 'No account yet?',
    hasAccount: 'Already have an account?',
    resetTitle: 'Reset password',
    newPassword: 'New password',
    resetSent: 'If an account exists, an email has just been sent.',
    verifyTitle: 'Email verification',
    verifySuccess: 'Your email address is confirmed.',
    verifyError: 'Invalid or expired link.',
    logoutDone: 'You are signed out.',
    welcomeBack: 'Welcome back',
    createAccount: 'Create your organizer space',
    passwordHint: 'At least 10 characters.',
    emailVerificationRequired: 'Check your inbox to activate your account.',
  },
  status: {
    DRAFT: 'Draft',
    READY: 'Ready',
    RUNNING: 'Running',
    PAUSED: 'Paused',
    RECOVERY_PENDING: 'Recovery',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
  },
  dashboard: {
    title: 'Dashboard',
    greeting: 'Hello {{name}}',
    subtitle: 'Your tournaments, your chip cases, your pace.',
    activeTournament: 'Live tournament',
    upcoming: 'Upcoming',
    recent: 'Recent',
    noTournaments: 'No tournaments yet.',
    createFirst: 'Create your first tournament',
    playersCount: '{{count}} players',
    openConsole: 'Open console',
    stats: 'Your stats',
    tournamentsPlayed: 'Tournaments played',
    wins: 'Wins',
    podiums: 'Podiums',
  },
  tournament: {
    new: 'New tournament',
    name: 'Tournament name',
    chipCase: 'Chip case',
    preset: 'Start from a preset',
    stepInfo: 'Information',
    stepChips: 'Buy-ins',
    stepBlinds: 'Structure',
    stepOptions: 'Options',
    playersExpected: 'Expected players',
    buyIn: 'Buy-in value',
    startingStack: 'Starting stack',
    targetDuration: 'Target duration (min)',
    levelDuration: 'Level duration (min)',
    firstLevelDuration: 'First level (min)',
    followingLevelDuration: 'Following levels (min)',
    breakDuration: 'Break duration (min)',
    breakEvery: 'Break every',
    roundUnit: 'Blind rounding',
    autoStructure: 'Auto-generate',
    manualStructure: 'Enter manually',
    distribution: 'Buy-in distribution',
    exactDistribution: 'Exact value',
    approximateDistribution: 'Approximate value: {{difference}} off',
    chipsPerPlayer: '{{count}} chips per player',
    start: 'Start tournament',
    pause: 'Pause',
    resume: 'Resume',
    nextLevel: 'Next level',
    previousLevel: 'Previous level',
    addMinute: '+1 min',
    addFiveMinutes: '+5 min',
    complete: 'Complete',
    cancelTournament: 'Cancel tournament',
    finalize: 'Declare winner',
    console: 'Console',
    players: 'Players',
    structure: 'Structure',
    ranking: 'Ranking',
    share: 'Share',
    history: 'History',
    addPlayer: 'Add player',
    playerName: 'Player name',
    eliminate: 'Eliminate',
    undoElimination: 'Undo last elimination',
    rebuy: 'Rebuy',
    addOn: 'Add-on',
    rebuyCount: '{{count}} rebuy(s)',
    activePlayers: '{{count}} still in',
    spectatorLink: 'Spectator link',
    createSpectatorLink: 'Create spectator link',
    spectatorHint: 'Share this link: read-only access, revocable at any time.',
    revoke: 'Revoke',
    projection: 'Projection mode',
    winner: 'Winner',
    finalRanking: 'Final ranking',
    noPlayers: 'No players registered.',
    lateRegistration: 'Late registration',
    pin: 'Security PIN',
    pinHint: '4 to 8 digits. Optional, locks clock commands.',
    unlock: 'Unlock',
    pinRequired: 'This tournament is PIN-protected.',
    buyInSummary: 'Buy-in {{value}}',
    totalChips: '{{count}} chips total',
    stockWarning: 'Insufficient stock',
    levelUpSoon: 'Next level in',
    onBreak: 'Break',
    structureExhausted: 'Structure exhausted: extend or complete the tournament.',
    extendStructure: 'Extend structure',
  },
  chipCase: {
    title: 'Chip cases',
    subtitle: 'Your physical chip inventory.',
    new: 'New chip case',
    edit: 'Edit chip case',
    name: 'Chip case name',
    description: 'Description',
    chipLabel: 'Label',
    color: 'Color',
    value: 'Value',
    quantity: 'Quantity',
    addChipType: 'Add chip type',
    totalValue: 'Total stock value',
    uniqueValues: 'Each value must be unique.',
    inUse: 'Used by {{count}} tournament(s)',
    adjust: 'Adjust stock',
    adjustmentReason: 'Adjustment reason',
    freeStock: '{{count}} available',
    empty: 'No chip case yet. Create the first one to get started.',
  },
  preset: {
    title: 'Presets',
    subtitle: 'Your reusable configurations.',
    new: 'New preset',
    edit: 'Edit preset',
    name: 'Preset name',
    description: 'Description',
    empty: 'No saved preset.',
    use: 'Use in a tournament',
    version: 'Version {{version}}',
  },
  stats: {
    title: 'Stats',
    subtitle: 'Your journey, tournament after tournament.',
    played: 'Tournaments played',
    wins: 'Wins',
    podiums: 'Podiums',
    bestRank: 'Best finish',
    averageRank: 'Average finish',
    rebuys: 'Rebuys',
    addOns: 'Add-ons',
    noResults: 'No results yet.',
    history: 'Participation history',
    rank: 'Rank',
    tournament: 'Tournament',
  },
  account: {
    title: 'Account',
    subtitle: 'Profile, security and personal data.',
    profile: 'Profile',
    security: 'Security',
    data: 'Data',
    currentPassword: 'Current password',
    newPassword: 'New password',
    changePassword: 'Change password',
    exportData: 'Export my data (JSON)',
    deleteAccount: 'Delete my account',
    deleteWarning:
      'This is irreversible. Your personal data is deleted and your participations anonymized.',
    deleteConfirm: 'Type DELETE to confirm.',
    publicProfile: 'Public profile',
    publicResults: 'Public results',
    language: 'Language',
    passwordChanged: 'Password updated.',
    dataExported: 'Export downloaded.',
    accountDeleted: 'Account deleted.',
  },
  spectator: {
    title: 'Live tournament',
    waiting: 'The tournament has not started yet.',
    players: 'Players still in',
    ranking: 'Ranking',
    live: 'Live',
    invalid: 'This spectator link is invalid or has been revoked.',
  },
  errors: {
    INVALID_CREDENTIALS: 'Incorrect email or password.',
    EMAIL_TAKEN: 'An account already exists with this address.',
    EMAIL_NOT_VERIFIED: 'Verify your email address before signing in.',
    CSRF_MISSING: 'Session expired, reload the page.',
    CSRF_INVALID: 'Invalid security token, reload the page.',
    RATE_LIMITED: 'Too many attempts, wait a minute.',
    VERSION_CONFLICT: 'The clock changed meanwhile. Refresh.',
    PIN_REQUIRED: 'Unlock the tournament with its PIN.',
    INVALID_PIN: 'Incorrect PIN.',
    INSUFFICIENT_STOCK: 'Not enough chips in stock.',
    NOT_ENOUGH_PLAYERS: 'At least two players are required.',
    DUPLICATE_PARTICIPANT: 'This name is already used in this tournament.',
    PLAYERS_REMAIN: 'Some players are still in.',
    REBUY_LIMIT_REACHED: 'Rebuy limit reached.',
    REBUY_PERIOD_OVER: 'The rebuy period is over.',
    UNKNOWN: 'Something went wrong.',
  },
} as const;

const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('pokero.locale') : null;

void i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
  },
  lng: stored === 'en' ? 'en' : 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
});

export default i18n;
